import React, { useState, useEffect, useMemo, useRef } from 'react';
import Home from "./components/AdsHome";
import Reserve from "./components/AdsReserve";
import Mypage from "../MyPage/MyPage";
import AdsMenuBar from "./components/detailComponents/AdsMenuBar";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import axios from 'axios';
import AdsHeader from '../../assets/components/AdsHeader';
import useImageListStore from '../../stores/imageList';
import useMainAppDataStore from '../../stores/mainAppData';
import { useRecordsStore } from '../../stores/useReordsStore';
import useInitAppDataStore from '../../stores/initAppData';
import { notifyWebLoadingDone } from '../../bridges/appBridge';
import TokenPopup from "./components/detailComponents/TokenPopup";
import { addAppMessageListener, postToApp } from "../../bridges/appBridge";
import { Bottom } from "../../assets/components/BottomSheetGroup";

// 🔥 sendTextZoom 제거

const AdsMain = () => {
    const scrollContainerRef = useRef(null);
    const galleryInputRef = useRef(null);
    const cameraInputRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [tokenAll, setTokenAll] = useState(0);
    const [appData, setAppData] = useState("");
    const [error, setError] = useState(null);
    const [showTokenModal, setShowTokenModal] = useState(false);
    const [showImagePickerSheet, setShowImagePickerSheet] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const initialState = location.state || {};
    const storeBusinessNumber =
        initialState.storeBusinessNumber || localStorage.getItem("store_business_number");
    const [tab, setTab] = useState(initialState.tab || "home");

    const { setImageList, getImageList } = useImageListStore();
    const today = useMemo(() => format(new Date(), 'yyyy-MM-dd'), []);
    const { setAppData: setAppDataZustand, getAppData } = useMainAppDataStore();
    const { setInitAppDataOnce } = useInitAppDataStore();
    const webReadySentRef = useRef(false);
    const pendingPushHandledRef = useRef(false);

    const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
    const isAndroid = useMemo(() => /Android/i.test(ua), [ua]);
    const isRN = typeof window !== "undefined" && !!window.ReactNativeWebView;
    const isAndroidRN = isAndroid && isRN;
    const isIOSRN = isRN && !isAndroidRN;

    // 기록
    const setRecordsZ = useRecordsStore((s) => s.setRecords);

    const closeMenu = () => { if (isMenuOpen) setIsMenuOpen(false); };

    // ✅ 환경 폰트 크기 영향 차단(전역 CSS 주입)
    useEffect(() => {
        const STYLE_ID = 'fix-text-zoom-global';
        if (!document.getElementById(STYLE_ID)) {
            const style = document.createElement('style');
            style.id = STYLE_ID;
            style.innerHTML = `
        html, body, #root {
          -webkit-text-size-adjust: 100% !important;
          text-size-adjust: 100% !important;
        }
      `;
            document.head.appendChild(style);
        }
        return () => { };
    }, []);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                setLoading(true);

                const cachedImageList = getImageList(storeBusinessNumber);
                const cachedAppData = getAppData(storeBusinessNumber, today);
                if (cachedImageList && cachedAppData) {
                    setAppData(cachedAppData);
                    setLoading(false);
                    return;
                }

                const response = await axios.post(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/select/init/info`,
                    null,
                    { params: { store_business_number: storeBusinessNumber } }
                );

                setInitAppDataOnce(response.data.user_id, response.data);
                const { all_image_list, insta_info, ...nextAppData } = response.data;

                setImageList(storeBusinessNumber, all_image_list);
                setAppData(nextAppData);
                setAppDataZustand(storeBusinessNumber, today, nextAppData);

                const ageDigit = response.data.ai_age?.[0];
                const aiReco = response.data.ai_data || [];
                localStorage.setItem("aiAge", ageDigit);
                localStorage.setItem("aiStyle", aiReco[0]);
                localStorage.setItem("aiCopy", aiReco[1]);
                localStorage.setItem("aiChannel", aiReco[2]);
                localStorage.setItem("aiTitle", aiReco[3]);
                localStorage.setItem("aiDay", aiReco[4]);
                localStorage.setItem("aiTime", aiReco[5]);
                localStorage.setItem("registerTag", response.data.register_tag);
                localStorage.setItem("customMenu", response.data.custom_menu);
                localStorage.setItem("store_business_number", storeBusinessNumber);
                localStorage.setItem("user_id", response.data.user_id);
                localStorage.setItem("login_provider", response.data.login_provider);
                if (response.data.id !== undefined && response.data.id !== null) {
                    localStorage.setItem("local_store_id", String(response.data.id));
                }
                localStorage.setItem("roadName", response.data.road_name);
                localStorage.setItem("storeName", response.data.store_name);
                localStorage.setItem("popup", response.data.popup);
                localStorage.setItem("re_popup", response.data.re_popup);
            } catch (err) {
                console.error("❌ 초기 데이터 로드 실패:", err);
                setError("조회 실패");
            } finally {
                setLoading(false);
            }
        };

        if (storeBusinessNumber) fetchInitialData();
    }, [
        storeBusinessNumber,
        today,
        getAppData,
        getImageList,
        setAppDataZustand,
        setImageList,
        setInitAppDataOnce,
    ]);

    const moveToGalleryWithFile = (file, previewUrl) => {
        navigate("/manual/marketing/gallery", {
            state: {
                ...(appData || {}),
                imageFile: file,
                imageDataUrl: previewUrl,
                initialImageFromMenu: true,
            },
        });
    };

    const decodeDataUrlToFile = (dataUrl, fileName = "picked.jpg") => {
        const [header, body] = String(dataUrl || "").split(",");
        const mime = header?.match(/:(.*?);/)?.[1] || "image/jpeg";
        const binary = atob(body || "");
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return new File([new Blob([bytes], { type: mime })], fileName, { type: mime });
    };

    const handlePickedImageMessage = (payload = {}) => {
        const dataUrl =
            payload?.dataUrl ||
            (Array.isArray(payload?.dataUrls) && payload.dataUrls.length > 0
                ? payload.dataUrls[0]
                : null);

        if (dataUrl) {
            try {
                const file = decodeDataUrlToFile(dataUrl);
                moveToGalleryWithFile(file, dataUrl);
                return true;
            } catch (e) {
                alert("이미지 처리에 실패했습니다.");
                return true;
            }
        }

        if (payload?.uri) {
            navigate("/manual/marketing/gallery", {
                state: {
                    ...(appData || {}),
                    imageUri: payload.uri,
                    initialImageFromMenu: true,
                },
            });
            return true;
        }

        return false;
    };

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            moveToGalleryWithFile(file, reader.result);
        };
        reader.readAsDataURL(file);
    };

    const openGalleryInput = () => {
        if (!galleryInputRef.current) return;
        galleryInputRef.current.value = "";
        setTimeout(() => galleryInputRef.current?.click(), 120);
    };

    const openCameraInput = () => {
        if (!cameraInputRef.current) return;
        cameraInputRef.current.value = "";
        setTimeout(() => cameraInputRef.current?.click(), 120);
    };

    const openNativeGallery = () => {
        try {
            postToApp({
                type: "OPEN_IMAGE_PICKER",
                payload: { at: Date.now(), reason: "home_camera_gallery", source: "gallery" },
            });
        } catch (_) { }

        try {
            window.Android?.openGallery?.();
        } catch (_) { }
    };

    const openNativeCamera = () => {
        try {
            postToApp({
                type: "OPEN_IMAGE_PICKER",
                payload: { at: Date.now(), reason: "home_camera_camera", source: "camera" },
            });
        } catch (_) { }

        const hasNativeCamera = typeof window.Android?.openCamera === "function";
        try {
            if (hasNativeCamera) {
                window.Android.openCamera();
            }
        } catch (_) { }

        return hasNativeCamera;
    };

    const handleMyPhotoClick = () => {
        if (tokenAll <= 0) {
            setShowTokenModal(true);
            return;
        }

        setShowImagePickerSheet(true);
    };

    const handleSelectCamera = () => {
        setShowImagePickerSheet(false);

        if (isAndroidRN) {
            const openedByNative = openNativeCamera();
            if (!openedByNative) {
                openCameraInput();
            }
            return;
        }

        if (isIOSRN) {
            openCameraInput();
            return;
        }

        openCameraInput();
    };

    const handleSelectAlbum = () => {
        setShowImagePickerSheet(false);

        if (isAndroidRN) {
            openNativeGallery();
            return;
        }

        if (isIOSRN) {
            openNativeGallery();
            setTimeout(() => {
                openGalleryInput();
            }, 400);
            return;
        }

        openGalleryInput();
    };

    const handleSelectStoredImage = () => {
        setShowImagePickerSheet(false);
        navigate("/manual/marketing/gallery/stored-images", {
            state: {
                ...(appData || {}),
            },
        });
    };

    useEffect(() => {
        if (!isRN) return;

        const off = addAppMessageListener((msg) => {
            const type = msg?.type;
            const payload = msg?.payload || {};

            if (type === "PICK_IMAGE_RESULT") {
                const handled = handlePickedImageMessage(payload);
                if (!handled) {
                    alert("이미지 결과가 비어 있습니다.");
                }
                return;
            }

            if (type === "PICK_IMAGE_ERROR") {
                alert(payload?.message || "이미지 선택 중 오류가 발생했습니다.");
            }
        });

        return () => {
            try {
                off?.();
            } catch (_) { }
        };
    }, [appData, isRN, navigate]);

    useEffect(() => {
        const originalReceive = window.receiveCameraImage;

        window.receiveCameraImage = function (dataUri) {
            if (!dataUri) {
                alert("?대?吏 寃곌낵媛 鍮꾩뼱 ?덉뒿?덈떎.");
                return;
            }

            handlePickedImageMessage({ dataUrl: dataUri });
        };

        return () => {
            window.receiveCameraImage = originalReceive;
        };
    }, []);

    useEffect(() => {
        const user_id = localStorage.getItem("user_id");
        const fetchToken = async () => {
            try {
                const tokenResponse = await axios.get(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ticket/token`,
                    { params: { user_id } }
                );
                setTokenAll(tokenResponse.data.remaining_tokens_total);
            } catch (err) {
                console.error("❌ 토큰 정보 조회 실패:", err);
            }
        };
        fetchToken();
    }, []);

    // ✅ 최초 한번: 전체 기록 가져오기
    useEffect(() => {
        const userId = localStorage.getItem("user_id");
        const sendGenerateRequest = async () => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/user/reco`,
                    { userId },
                    { headers: { "Content-Type": "application/json" } }
                );
                const rawRecords = response.data.record || [];
                const normalized = Array.isArray(rawRecords) ? rawRecords : [rawRecords];
                setRecordsZ(normalized);
            } catch (error) {
                console.error("자동화 광고 생성 중 오류:", error);
                alert("광고 생성에 실패했습니다. 다시 시도해주세요.");
            }
        };
        sendGenerateRequest();
    }, [setRecordsZ]);

    useEffect(() => {
        if (loading) return;
        if (webReadySentRef.current) return;
        webReadySentRef.current = true;
        notifyWebLoadingDone("AdsMain");
    }, [loading]);

    useEffect(() => {
        if (loading) return;
        if (!appData) return;
        if (pendingPushHandledRef.current) return;

        const raw = localStorage.getItem("pending_push");
        if (!raw) return;

        pendingPushHandledRef.current = true;
        localStorage.removeItem("pending_push");

        let cmd = {};
        try { cmd = JSON.parse(raw) || {}; } catch { }

        if (cmd.action === "HOME_ONCREATE" || cmd.route === "/manual/marketing/ai") {
            navigate("/manual/marketing/ai", { replace: true, state: appData });
            return;
        }

        if (cmd.route) {
            navigate(cmd.route, { replace: true });
        }
    }, [loading, appData, navigate]);

    // ✅ location.state.tab은 "초기 1회"만 흡수하고 바로 비움
    const didHydrateTabFromState = useRef(false);
    useEffect(() => {
        if (didHydrateTabFromState.current) return;
        const incoming = location.state?.tab;
        if (incoming != null) setTab(incoming);
        didHydrateTabFromState.current = true;
        navigate(".", { replace: true, state: null });
    }, [location.state, navigate]);

    const handleTabChange = async (newTab) => {
        if (newTab === "report") {
            try {
                const store_business_number = localStorage.getItem("store_business_number");
                if (!store_business_number) {
                    alert("사업자 번호가 없습니다. 다시 로그인 해주세요.");
                    return;
                }

                const payload = { store_business_id: store_business_number };
                const response = await axios.post(
                    `${process.env.REACT_APP_FASTAPI_REPORT_URL}/report/get/store/uuid`,
                    payload,
                    { headers: { "Content-Type": "application/json" } }
                );

                const { uuid } = response.data;
                const REPORT_PATH = `/report/${encodeURIComponent(uuid)}`;
                const REPORT_URL = `${process.env.REACT_APP_REPORT}${REPORT_PATH}?uuid=${encodeURIComponent(uuid)}`;

                navigate(`/inapp?url=${encodeURIComponent(REPORT_URL)}`);
            } catch (error) {
                console.error("리포트 열기 실패:", error);
                alert("리포트 조회 중 오류가 발생했습니다.");
            }
            return;
        }

        setTab(newTab);

        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: 0,
                left: 0,
                behavior: "auto",
            });
        }
    };

    const renderPage = () => {
        switch (tab) {
            case "home":
                return (
                    <Home
                        appData={appData}
                        tokenAll={tokenAll}
                        onMyPhotoClick={handleMyPhotoClick}
                    />
                );
            case "reserve":
                return <Reserve data={appData} />;
            case "mypage":
                return <Mypage data={appData} />;
            default:
                return <Home />;
        }
    };

    if (error) {
        return (
            <div className="inset-0 flex items-center justify-center h-screen bg-white z-50">
                <p className="text-red-500 text-lg font-semibold">{error}</p>
            </div>
        );
    }

    return (
        <div
            ref={scrollContainerRef}
            onClick={closeMenu}
            className="min-h-0 overflow-y-auto overscroll-contain h-dvh"
            style={{
                WebkitTextSizeAdjust: '100%',
                textSizeAdjust: '100%',
            }}
        >
            <div>
                <AdsHeader data={appData} tab={tab} />
            </div>

            <div>{renderPage()}</div>

            <input
                ref={galleryInputRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleFileChange}
            />

            <input
                ref={cameraInputRef}
                type="file"
                accept="image/*"
                capture="environment"
                className="hidden"
                onChange={handleFileChange}
            />

            <TokenPopup
                isOpen={showTokenModal}
                onClose={() => setShowTokenModal(false)}
            />

            <Bottom
                isOpen={showImagePickerSheet}
                onClose={() => setShowImagePickerSheet(false)}
                title="이미지 선택"
                height="h-[360px]"
            >
                <div className="flex flex-col gap-3 pb-6">
                    <button
                        type="button"
                        onClick={handleSelectCamera}
                        className="w-full rounded-[20px] border border-border-subtle bg-white px-5 py-4 text-left"
                    >
                        <div className="text-b1 text-text-default">카메라 촬영</div>
                        <div className="mt-1 text-c1 text-text-subtler">지금 촬영한 사진으로 바로 시작할 수 있어요.</div>
                    </button>

                    <button
                        type="button"
                        onClick={handleSelectAlbum}
                        className="w-full rounded-[20px] border border-border-subtle bg-white px-5 py-4 text-left"
                    >
                        <div className="text-b1 text-text-default">앨범 선택</div>
                        <div className="mt-1 text-c1 text-text-subtler">휴대폰에 저장된 이미지 중 원하는 사진을 선택해 주세요.</div>
                    </button>

                    <button
                        type="button"
                        onClick={handleSelectStoredImage}
                        className="w-full rounded-[20px] border border-border-subtle bg-white px-5 py-4 text-left"
                    >
                        <div className="text-b1 text-text-default">저장된 이미지 선택</div>
                        <div className="mt-1 text-c1 text-text-subtler">컨시어지에 저장된 매장 사진 1장을 골라 사용할 수 있어요.</div>
                    </button>
                </div>
            </Bottom>

            <div className="fixed bottom-0 left-0 w-full z-50">
                <div
                    className="
            bg-surface-light-white rounded-t-[30px] overflow-visible
            shadow-[0_-4px_4px_rgba(0,0,0,0.06)]
          "
                >
                    <AdsMenuBar
                        tab={tab}
                        setTab={handleTabChange}
                        data={appData}
                        onCameraClick={handleMyPhotoClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default AdsMain;
